export const arrayMergeByKey = <T extends Record<string, unknown>>(
  key: string,
  a: T[],
  b: T[],
  allowArrayAMutation = true,
) => {
  const mergedMap = new Map<string | number, T>()
  for (const i of a) {
    const keyField = i[key] as string | number
    if (typeof keyField !== 'string' && typeof keyField !== 'number') continue
    mergedMap.set(keyField, i)
  }
  for (const i of b) {
    const keyField = i[key] as string | number
    if (typeof keyField !== 'string' && typeof keyField !== 'number') continue
    const existing = mergedMap.get(keyField)
    if (existing) {
      if (allowArrayAMutation) {
        Object.assign(existing, i)
      } else {
        mergedMap.set(keyField, { ...existing, ...i })
      }
    } else {
      mergedMap.set(keyField, i)
    }
  }
  return Array.from(mergedMap.values())
}
